/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const SimulationStatus = {
    PreDraft: 'PreDraft',
    Draft: 'Draft',
    LocalReview: 'LocalReview',
    GlobalReview: 'GlobalReview',
    Published: 'Published',
    Error: 'Error'
} as const;
export type SimulationStatus = typeof SimulationStatus[keyof typeof SimulationStatus];


export function instanceOfSimulationStatus(value: any): boolean {
    for (const key in SimulationStatus) {
        if (Object.prototype.hasOwnProperty.call(SimulationStatus, key)) {
            if (SimulationStatus[key as keyof typeof SimulationStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function SimulationStatusFromJSON(json: any): SimulationStatus {
    return SimulationStatusFromJSONTyped(json, false);
}

export function SimulationStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): SimulationStatus {
    return json as SimulationStatus;
}

export function SimulationStatusToJSON(value?: SimulationStatus | null): any {
    return value as any;
}

export function SimulationStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): SimulationStatus {
    return value as SimulationStatus;
}

